import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from 'styled-components';
import { Carregando } from './components/Carregando';
import { ProvedorUsuario } from './contextos/usuario/ProvedorUsuario';
import Routes from './routes/Routes';
import EstilosGlobais, { Conteiner } from './styles/estilosGlobais';
import { temaClaro } from './styles/tema';

function App() {
  return (
    <Conteiner>
      <ThemeProvider theme={temaClaro}>
        <ProvedorUsuario>
          <EstilosGlobais />
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
          <ToastContainer pauseOnFocusLoss={false} autoClose={3000} />
          <Carregando />
        </ProvedorUsuario>
      </ThemeProvider>
    </Conteiner>
  );
}

export default App;
